
import api from '@/apis/api'
import NameAvatar from '@/components/NameAvatar.vue'
import { RouteName } from '@/router'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  components: {
    NameAvatar,
  },
})
export default class SignIn extends Vue {
  username = ''
  password = ''
  waiting = false
  passwordObscured = true

  async signIn(): Promise<void> {
    this.waiting = true
    try {
      const user = await api.signIn(this.username, this.password)
      this.$store.commit('setUser', user)
      this.$router.push({ name: RouteName.home })
    } catch (e) {
      this.$store.dispatch('snackbar', { message: e, isError: true })
    } finally {
      this.waiting = false
    }
  }
}
